import React from 'react'
import styled from 'styled-components'
import { Button } from 'antd'
import { WarningOutlined } from '@ant-design/icons'
import Modal from '@shared/Modal'
import { useTranslation } from 'react-i18next'

type IForgotPassowrdModalProp = {
  visible?: boolean
  onOk?: () => void
}

const ForgotPassowrdModal = React.memo<IForgotPassowrdModalProp>(props => {
  const { t } = useTranslation()

  const { visible, onOk } = props

  return (
    <ForgotPassowrdModalStyled
      open={visible}
      footer={
        <div className="flex justify-center">
          <Button type="primary" onClick={onOk}>
            {t('common:confirmed')}
          </Button>
        </div>
      }
      centered
      closable={false}>
      <div className="flex justify-center items-center text-lg">
        <WarningOutlined style={{ color: '#f8a204', fontSize: '3rem', marginRight: '15px' }} />
        {t('system:contact admin')}
      </div>
    </ForgotPassowrdModalStyled>
  )
})

const ForgotPassowrdModalStyled = styled(Modal)`
  .ant-modal-content {
    border-radius: 10px;
  }
  .ant-modal-body {
    background-color: #e7f3fd;
    padding: 60px 15px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
  .ant-modal-footer {
    background-color: #e7f3fd;
  }
`

export default ForgotPassowrdModal
